// Bobs Antworttext: einfache Markdown-Teilmenge (Absätze, Listen, **fett**) mit Links auf Threads
// ([Betreff](thread:ID)) und CRM-Datensätze ([Name](crm:recID)).
import { Fragment, type ReactNode } from 'react';
import { Link } from 'react-router';

const CRM = 'https://admin.minimusiker.de';

function inline(text: string, key: string) {
  const parts: ReactNode[] = [];
  const re =
    /\[([^\]]+)\]\((thread:(\d+)|crm:(rec[A-Za-z0-9]{14})|https?:[^)]+)\)|\*\*([^*]+)\*\*/g;
  let last = 0;
  let i = 0;
  for (const m of text.matchAll(re)) {
    parts.push(text.slice(last, m.index));
    const k = `${key}-${i++}`;
    if (m[5]) parts.push(<b key={k}>{m[5]}</b>);
    else if (m[3])
      parts.push(
        <Link key={k} to={`/t/${m[3]}`}>
          {m[1]}
        </Link>,
      );
    else if (m[4])
      parts.push(
        <a key={k} href={`${CRM}/#institutions:${m[4]}`} target="_blank" rel="noopener">
          {m[1]} ↗
        </a>,
      );
    else
      parts.push(
        <a key={k} href={m[2]} target="_blank" rel="noopener noreferrer">
          {m[1]}
        </a>,
      );
    last = (m.index ?? 0) + m[0].length;
  }
  parts.push(text.slice(last));
  return parts;
}

export function BobAntwort({ text }: { text: string }) {
  const blocks = text.split(/\n{2,}/);
  return (
    <div>
      {blocks.map((b, bi) => {
        const lines = b.split('\n');
        if (lines.every((l) => /^\s*[-•*]\s+/.test(l)))
          return (
            <ul key={bi} style={{ margin: '4px 0', paddingLeft: 18 }}>
              {lines.map((l, li) => (
                <li key={li}>{inline(l.replace(/^\s*[-•*]\s+/, ''), `${bi}-${li}`)}</li>
              ))}
            </ul>
          );
        return (
          <p key={bi} style={{ margin: '4px 0' }}>
            {lines.map((l, li) => (
              <Fragment key={li}>
                {li > 0 && <br />}
                {inline(l, `${bi}-${li}`)}
              </Fragment>
            ))}
          </p>
        );
      })}
    </div>
  );
}
